export default __webpack_public_path__ + "static/media/about-pic.d2b1f05b.JPG";